function getCookie(name: string) {
  const cookie: Record<string, string | undefined> = {}
  document.cookie.split(';').forEach(item => {
    const [key, value] = item.split('=')
    cookie[key.trim()] = value
  })
  return cookie[name]
}

export const getUtmParametersFromCookie = (): Nullable<UTMParams> => {
  const defaultValue: Nullable<UTMParams> = {
    utm_source: null,
    utm_medium: null,
    utm_campaign: null
  }

  const campaignUrl = getCookie('__gtm_campaign_url')
  const decodedCampaignUrl = campaignUrl
    ? decodeURIComponent(campaignUrl)
    : null

  if (!decodedCampaignUrl) return defaultValue

  try {
    const url = new URL(decodedCampaignUrl ?? '')
    const params = new URLSearchParams(url.search)
    return {
      utm_source: params.get('utm_source'),
      utm_campaign: params.get('utm_campaign'),
      utm_medium: params.get('utm_medium')
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error)
    return defaultValue
  }
}
